import { useEffect, useState } from "react";
import { callApi } from "../../services/ApiServices";
import CommonLoader from "../common/CommonLoader";
import { ImagePath } from "../common/ImagePath";
import CommonPagination from "../common/CommonPagination";

const ExploreClubsRequests = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [contactUsListing, setContactUsListing] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 10;
  useEffect(() => {
    fetchEngagementsListing(currentPage, limit, searchQuery);
  }, []);

  const fetchEngagementsListing = async (page, limit, search) => {
    const trimmedSearch = search?.trim();
    if (search && !trimmedSearch) {
      return;
    }
    if (!search) {
      setLoading(true);
    }
    try {
      let ApiUrl = `engagements?page=${page}&limit=${limit}`;
      if (trimmedSearch) {
        ApiUrl += `&search=${trimmedSearch}`;
      }
      const response = await callApi({
        method: "get",
        url:ApiUrl,
      });
      console.log("engagements", response);

      setContactUsListing(response?.data);
      const totalitems = response?.pagination?.total
      const totalPages = Math.ceil(totalitems / limit);
      setTotalCount(totalPages)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching engagements  listing:", error);
      setLoading(false);
    }
  };

  const handlePageChange =(e)=>{
  setCurrentPage(e)
  fetchEngagementsListing(e, limit, searchQuery)
}


  return (
    <div className="space-y-6">
      {/* Search Bar */}
      {loading && <CommonLoader fullScreen />}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 max-w-[314px]">
        <div className="relative">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textcolor"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            type="text"
            placeholder="Search by name and email..."
            value={searchQuery}
            onChange={(e) => {setSearchQuery(e.target.value)
          setCurrentPage(1)
          fetchEngagementsListing(1, limit, e.target.value)
          }}
            onKeyDown={(e) => {
              if (e.key === " " && searchQuery?.length === 0) {
                e.preventDefault();
              }
            }}
            className="w-full pl-10 pr-4 py-2.5 border-0 focus:outline-none text-base text-textcolor placeholder:text-textcolor"
          />
        </div>
      </div>

      {/* Advertisers Table */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#fafafa] border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  First Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Last Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Email
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {contactUsListing?.length > 0 ? (
                contactUsListing?.map((contact, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-3">
                      {contact?.contact_us_firstName || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {contact?.contact_us_lastName || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {contact?.contact_us_email || "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="px-6 py-3 text-sm font-normal text-textcolor"
                  >
                    <div className="flex justify-center items-center mt-5">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2 text-center">No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
        <CommonPagination
        pageCount={totalCount}
        currentPage={currentPage}
        onPageChange={(e) => handlePageChange(e)}
      />
    </div>
  );
};

export default ExploreClubsRequests;
